module.exports = __webpack_public_path__ + "img/international_carrier_icon.950fb9b8.svg";